import {
  resolveMutationErrorKey,
  type MutationErrorLike,
} from "@/partner/shared/lib";

/** Коды отказов API опросов (текст сообщения UserInputError/ForbiddenError). */
export type PollErrorCode =
  | "POLL_IN_USE"
  | "POLL_LOCKED"
  | "POLL_NOT_EDITABLE"
  | "STREAM_NOT_STARTED"
  | "POLL_NOT_OPENABLE"
  | "POLL_NOT_ACTIVE"
  | "PLAYER_POLLS_DISABLED";

export const POLL_ERROR_KEYS: Record<PollErrorCode, string> = {
  POLL_IN_USE: "pollErrors.inUse",
  POLL_LOCKED: "pollErrors.locked",
  POLL_NOT_EDITABLE: "pollErrors.notEditable",
  STREAM_NOT_STARTED: "pollErrors.streamNotStarted",
  POLL_NOT_OPENABLE: "pollErrors.notOpenable",
  POLL_NOT_ACTIVE: "pollErrors.notActive",
  PLAYER_POLLS_DISABLED: "pollErrors.disabled",
};

export const POLL_ERROR_FALLBACK_KEY = "pollErrors.unknown";

/** Ключ перевода для ошибки мутации опросов; сырой message не показываем. */
export function pollErrorKey(
  error: MutationErrorLike | null | undefined
): string {
  return resolveMutationErrorKey(
    error,
    POLL_ERROR_KEYS,
    POLL_ERROR_FALLBACK_KEY
  );
}
